import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { BalanceSheetCellPosition, BalanceSheetDensity } from '../../BalanceSheetTable.types';
import { useBalanceSheetHeaderGroupStyles } from './BalanceSheetHeaderGroup.styles';
export interface BalanceSheetHeaderGroupProps {
  /**
   * Header group text (e.g., "IN ESTATE", "OUT OF ESTATE").
   * Only rendered on the first column slot in each group; subsequent
   * slots pass undefined so the text appears once, left-aligned.
   */
  text?: string;
  /** Horizontal alignment for the group label. */
  alignment?: 'left' | 'right';
  /**
   * Density setting affecting padding
   */
  density: BalanceSheetDensity;
  /**
   * Position of the corresponding column below this slot.
   * Controls horizontal padding so the header group cell matches
   * the column header/data cell widths exactly.
   */
  cellPosition: BalanceSheetCellPosition;
  /**
   * Whether this is in a presentation context (grayscale colors)
   */
  isPresentation?: boolean;
  /**
   * Optional minimum width for the header group cell.
   */
  minWidth?: number;
  /**
   * Optional maximum width for the header group cell.
   */
  maxWidth?: number;
  /**
   * Whether to render a 4px column gap after this header group cell.
   * Used to create visual separation between in-estate and out-of-estate sections.
   */
  hasColumnGap?: boolean;
}

/**
 * BalanceSheetHeaderGroup renders a single column-width slot in the header
 * group row. One slot is rendered per visible column so that the header group
 * row has the same flex structure as the column header and data rows below,
 * ensuring the column gap aligns perfectly across all row types.
 *
 * The group label (e.g., "IN ESTATE") is only shown in the first slot of
 * each group; subsequent slots are visually empty but still occupy space.
 */
export function BalanceSheetHeaderGroup(t0) {
  const $ = _c(19);
  const {
    text,
    alignment: t1,
    density,
    cellPosition,
    isPresentation: t2,
    minWidth,
    maxWidth,
    hasColumnGap: t3
  } = t0;
  const alignment = t1 === undefined ? "left" : t1;
  const isPresentation = t2 === undefined ? false : t2;
  const hasColumnGap = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== alignment || $[1] !== cellPosition || $[2] !== density || $[3] !== isPresentation || $[4] !== maxWidth || $[5] !== minWidth) {
    t4 = {
      density,
      alignment,
      isPresentation,
      cellPosition,
      minWidth,
      maxWidth
    };
    $[0] = alignment;
    $[1] = cellPosition;
    $[2] = density;
    $[3] = isPresentation;
    $[4] = maxWidth;
    $[5] = minWidth;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    classes
  } = useBalanceSheetHeaderGroupStyles(t4);
  let t5;
  if ($[7] !== classes.text || $[8] !== text) {
    t5 = text && <Box component="span" className={classes.text}>{text}</Box>;
    $[7] = classes.text;
    $[8] = text;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== classes.root || $[11] !== t5) {
    t6 = <Box className={classes.root}>{t5}</Box>;
    $[10] = classes.root;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== classes.columnGap || $[14] !== hasColumnGap) {
    t7 = hasColumnGap && <Box className={classes.columnGap} />;
    $[13] = classes.columnGap;
    $[14] = hasColumnGap;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}